import { useParams, Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/data';

const articleDetailImages: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Professional%20video%20streaming%20platform%20review%20scene%20with%20warm%20orange%20and%20golden%20lighting%2C%20abstract%20comparison%20elements%20representing%20multiple%20platforms%2C%20modern%20tech%20review%20atmosphere%2C%20clean%20minimalist%20composition%2C%20no%20text&width=1200&height=600&seq=article-detail-1&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Three%20abstract%20platforms%20side%20by%20side%20with%20warm%20orange%20teal%20and%20amber%20gradients%2C%20modern%20comparison%20layout%20with%20soft%20cinematic%20lighting%2C%20clean%20tech%20aesthetic%2C%20no%20text&width=1200&height=600&seq=article-detail-2&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Summer%20movie%20cinematic%20collage%20with%20warm%20golden%20hour%20lighting%2C%20film%20reels%20and%20theater%20elements%2C%20abstract%20entertainment%20atmosphere%2C%20vibrant%20yet%20warm%20composition%2C%20no%20text&width=1200&height=600&seq=article-detail-3&orientation=landscape',
  'article-4': 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20video%20app%20interface%20with%20warm%20orange%20theme%2C%20modern%20mobile%20device%20on%20minimalist%20desk%20setup%2C%20soft%20natural%20lighting%2C%20clean%20lifestyle%20tech%20aesthetic%2C%20no%20text&width=1200&height=600&seq=article-detail-4&orientation=landscape',
  'article-5': 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20drama%20cinematic%20atmosphere%20with%20warm%20amber%20lighting%2C%20abstract%20storytelling%20elements%20with%20golden%20accents%2C%20sophisticated%20entertainment%20composition%2C%20no%20people%20or%20text&width=1200&height=600&seq=article-detail-5&orientation=landscape',
  'article-6': 'https://readdy.ai/api/search-image?query=Warm%20community%20feedback%20and%20ratings%20visualization%20with%20glowing%20orange%20stars%2C%20abstract%20user%20satisfaction%20concept%2C%20modern%20minimalist%20design%2C%20soft%20ambient%20lighting%2C%20no%20text&width=1200&height=600&seq=article-detail-6&orientation=landscape',
  'article-7': 'https://readdy.ai/api/search-image?query=Ultra%20HD%204K%20cinematic%20visual%20with%20crystal%20clear%20details%20and%20warm%20orange%20lighting%2C%20premium%20entertainment%20quality%20aesthetic%2C%20abstract%20technology%20elements%2C%20no%20text&width=1200&height=600&seq=article-detail-7&orientation=landscape',
  'article-8': 'https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20abstract%20background%20with%20warm%20soft%20pastel%20colors%20and%20gentle%20light%20rays%2C%20dreamy%20atmosphere%20with%20floating%20geometric%20shapes%2C%20creative%20composition%2C%20no%20characters&width=1200&height=600&seq=article-detail-8&orientation=landscape',
  'article-9': 'https://readdy.ai/api/search-image?query=Three%20way%20comparison%20dashboard%20with%20warm%20orange%20teal%20and%20amber%20accents%2C%20modern%20data%20visualization%20with%20soft%20cinematic%20lighting%2C%20clean%20review%20aesthetic%2C%20no%20text&width=1200&height=600&seq=article-detail-9&orientation=landscape',
  'article-10': 'https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20nature%20documentary%20aesthetic%20with%20rich%20earthy%20tones%2C%20cinematic%20landscape%20photography%20style%2C%20atmospheric%20composition%20with%20depth%20and%20soft%20lighting%2C%20no%20text&width=1200&height=600&seq=article-detail-10&orientation=landscape',
  'article-11': 'https://readdy.ai/api/search-image?query=Vibrant%20stage%20entertainment%20atmosphere%20with%20warm%20colorful%20spotlights%2C%20dynamic%20show%20lighting%20with%20orange%20and%20golden%20hues%2C%20abstract%20celebration%20composition%2C%20no%20text&width=1200&height=600&seq=article-detail-11&orientation=landscape',
  'article-12': 'https://readdy.ai/api/search-image?query=Two%20platforms%20comparison%20with%20warm%20orange%20and%20teal%20gradients%2C%20abstract%20versus%20layout%20with%20soft%20cinematic%20lighting%2C%20modern%20minimalist%20tech%20review%20aesthetic%2C%20no%20text&width=1200&height=600&seq=article-detail-12&orientation=landscape',
};

function getCategoryName(slug: string): string {
  const map: Record<string, string> = {
    recommend: '热门推荐',
    movie: '电影',
    tv: '电视剧',
    variety: '综艺',
    anime: '动漫',
    documentary: '纪录片',
  };
  return map[slug] || slug;
}

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === id);

  if (!article) {
    return (
      <>
        <SEOHead title="文章未找到 - 芒果视频" />
        <ScrollToTop />
        <Navbar />
        <main className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
              <i className="ri-file-unknow-line text-3xl"></i>
            </div>
            <h1 className="text-xl font-bold text-foreground-900 mb-2">文章未找到</h1>
            <p className="text-foreground-500 mb-6">该文章可能已被移除或链接失效</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-line"></i>
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const categoryName = getCategoryName(article.category);
  const relatedArticles = articles
    .filter((a) => a.category === article.category && a.id !== article.id)
    .slice(0, 3);

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.date,
    publisher: {
      '@type': 'Organization',
      name: '芒果视频',
    },
  };

  return (
    <>
      <SEOHead
        title={`${article.title} - 芒果视频`}
        description={article.excerpt}
        keywords={article.tags.join(',')}
        canonicalUrl={`https://www.mangoshipin.cn/article/${article.id}`}
        ogTitle={article.title}
        ogDescription={article.excerpt}
        ogType="article"
        ogUrl={`https://www.mangoshipin.cn/article/${article.id}`}
        schema={articleSchema}
      />
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: categoryName, href: `/category/${article.category}` },
            { label: article.title },
          ]}
        />

        <article className="w-full bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8 py-10 md:py-14">
            <header className="mb-8">
              <div className="flex flex-wrap items-center gap-3 mb-4">
                <Link
                  to={`/category/${article.category}`}
                  className="px-3 py-1 text-xs font-medium bg-primary-50 text-primary-700 rounded-full hover:bg-primary-100 transition-colors whitespace-nowrap"
                >
                  {categoryName}
                </Link>
                {article.tags.slice(0, 3).map((tag) => (
                  <span key={tag} className="px-3 py-1 text-xs bg-background-100 text-foreground-500 rounded-full whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>

              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900 mb-4 leading-tight">
                {article.title}
              </h1>

              <p className="text-base md:text-lg text-foreground-500 leading-relaxed mb-6">
                {article.excerpt}
              </p>

              <div className="flex items-center gap-4 text-sm text-foreground-400">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-line"></i>
                  {article.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line"></i>
                  {article.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line"></i>
                  {article.readTime}
                </span>
              </div>
            </header>

            <div className="w-full h-64 md:h-80 rounded-2xl overflow-hidden mb-10">
              <img
                src={articleDetailImages[article.id] || articleDetailImages['article-1']}
                alt={article.title}
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div
              className="prose-custom"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

            <div className="mt-10 pt-8 border-t border-background-200/60">
              <h3 className="text-sm font-semibold text-foreground-700 mb-3">文章标签</h3>
              <div className="flex flex-wrap gap-2">
                {article.tags.map((tag) => (
                  <span key={tag} className="px-4 py-1.5 text-xs bg-background-100 text-foreground-600 rounded-full whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-8">
                相关推荐
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {relatedArticles.map((rel) => (
                  <Link
                    key={rel.id}
                    to={`/article/${rel.id}`}
                    className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="relative w-full h-40 md:h-44 overflow-hidden">
                      <img
                        src={articleDetailImages[rel.id] || articleDetailImages['article-1']}
                        alt={rel.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {rel.title}
                      </h3>
                      <p className="text-xs text-foreground-400 mt-2">{rel.date}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>

      <Footer />
    </>
  );
}